import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendDown, faArrowTrendUp, faArrowsLeftRight, faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons";
import './PieChart.css'


const RevenueBox = ({revenue}) => {


  return (
    <div style={{display:"flex", justifyContent:"space-around"}}>
         <div style={{width:"30%",marginTop:"1em"}}>
            <FontAwesomeIcon style={{width:"20%"}} icon={faMoneyBillTransfer} />
            <h3>£{revenue.totalIncome}</h3>
            <h5>Total Revenue Generated</h5>
            </div>
         
         <div>
            
         </div>
         <div style={{ height: '10vh' , width:"30%",marginTop:"1em"}}>
      
      <div class="pie-chart">
    <div class="inner-circle">
    {revenue.percentageChange > 0 ? <FontAwesomeIcon icon={faArrowTrendUp} style={{color: "#26c030",}} /> :   <FontAwesomeIcon icon={faArrowsLeftRight} size='lg' style={{color: "#f4da2f",}} /> }
    </div>
  </div>
       <h5 className='percentage'>{revenue.percentageChange > 0 ? revenue.percentageChange + "%" : ''}</h5>
         </div>
     
    </div>
     
  );
};

export default RevenueBox;
